export enum UserRole {
  MEMBER = 'Member',
  STAFF = 'StaffUser',
}
